import config from "./config";

const directory = config.matchinggame.directory;
const matchingGame = [
    {
        category: "001 zh",
        link: `${config.flashUrl}/${directory}/001/index_T.html`,
        target: true
    },
    {
        category: "001 cn",
        link: `${config.flashUrl}/${directory}/001/index_S.html`,
        target: true
    },
    {
        category: "002 zh",
        link: `${config.flashUrl}/${directory}/002/index_T.html`,
        target: true
    },
    {
        category: "002 cn",
        link: `${config.flashUrl}/${directory}/002/index_S.html`,
        target: true
    },
    {
        category: "003 zh",
        link: `${config.flashUrl}/${directory}/003/index_T.html`,
        target: true
    },
    {
        category: "003 cn",
        link: `${config.flashUrl}/${directory}/003/index_T.html`,
        target: true
    },
    {
        category: "004 zh",
        link: `${config.flashUrl}/${directory}/004/index_T.html`,
        target: true
    },
    {
        category: "004 cn",
        link: `${config.flashUrl}/${directory}/004/index_T.html`,
        target: true
    },
    {
        category: "005 zh",
        link: `${config.flashUrl}/${directory}/005/index_T.html`,
        target: true
    },
    {
        category: "006 zh",
        link: `${config.flashUrl}/${directory}/006/index_T.html`,
        target: true
    },
    {
        category: "007 zh",
        link: `${config.flashUrl}/${directory}/007/index_T.html`,
        target: true
    },
    {
        category: "008 zh",
        link: `${config.flashUrl}/${directory}/008/index_T.html`,
        target: true
    },
    {
        category: "009 zh",
        link: `${config.flashUrl}/${directory}/009/index_T.html`,
        target: true
    },
    {
        category: "010 zh",
        link: `${config.flashUrl}/${directory}/010/index_T.html`,
        target: true
    }
];

export default matchingGame;
